// Base commons
import { RootState } from "app/store";
import FormType from "enums/FormType";
import { DefaultLimits } from "constants/DefaultLimits";

// Feature slices
import {
    isUndefinedOrNull,
    selectAnswerOption,
    selectFormType,
    selectAnswerOptionIdList,
} from "../qualityFormSlices/index";

export const hasMinimumAnswerOptions = (
    state: RootState,
    questionId: string,
    isMultipleSelect?: boolean
) => {
    const answerOptionIdList = selectAnswerOptionIdList(
        state,
        questionId,
        isMultipleSelect
    );

    const minAnswerOptions = isMultipleSelect
        ? DefaultLimits.minMultipleSelectQuestionOptionCount
        : DefaultLimits.minAnswerOptionCount;

    return (answerOptionIdList?.length ?? 0) > minAnswerOptions;
};

export const hasMaximumAnswerOptions = (
    state: RootState,
    questionId: string,
    isMultipleSelect?: boolean
) => {
    const answerOptionIdList = selectAnswerOptionIdList(
        state,
        questionId,
        isMultipleSelect
    );
    // multiple select, assessment, and survey have max answer options
    if (isMultipleSelect || selectFormType(state) !== FormType.EVALUATION) {
        return (
            (answerOptionIdList?.length ?? 0) >=
            DefaultLimits.maxAnswerOptionCount
        );
    }
    return false;
};

export const isAnswerOptionPointsEmpty = (
    state: RootState,
    answerOptionId: string,
    isMultipleSelect?: boolean
) => {
    const answerOption = selectAnswerOption(
        state,
        answerOptionId,
        isMultipleSelect
    );
    return isUndefinedOrNull(answerOption?.value);
};

export const isAnswerOptionPointsInDecimalNumber = (
    state: RootState,
    answerOptionId: string,
    isMultipleSelect?: boolean
) => {
    const answerOption = selectAnswerOption(
        state,
        answerOptionId,
        isMultipleSelect
    );
    const value = answerOption?.value;
    return !isUndefinedOrNull(value) && !Number.isInteger(value);
};

export const isAnswerOptionPointsOverLimits = (
    state: RootState,
    answerOptionId: string,
    isMultipleSelect?: boolean
) => {
    const answerOption = selectAnswerOption(
        state,
        answerOptionId,
        isMultipleSelect
    );
    const value = answerOption?.value;
    // Note that there is no need to check if this value is NaN here.
    // Even if value is NaN for some unlikely reason, the result will be an expected value: false.
    if (typeof value === "number") {
        if (selectFormType(state) === FormType.EVALUATION) {
            return value > DefaultLimits.maxJavaInt32;
        } else {
            return value > DefaultLimits.maxAnswerOptionPoints;
        }
    }
    return false;
};
